module.exports = "//cdn.mxpnl.com/static/asset-cache/2d936bf131847696f9a53f0b9a9bf318/iron/common/assets/images/charts/funnel-trends.svg";